import isNull from 'lodash/isNull'
import type { AnyAction, Store } from 'redux'

import type { RootReduxState } from 'types/redux/root'

class StoreRegistry {
    private _store: Store<RootReduxState> | null = null

    registerStore(store: Store<RootReduxState>): void {
        this._store = store
    }

    getState(): RootReduxState | null {
        return isNull(this._store) ? null : this._store.getState()
    }

    dispatch(action: AnyAction): unknown {
        return isNull(this._store) ? null : this._store.dispatch(action)
    }
}

export default new StoreRegistry()
